module.exports = __webpack_public_path__ + "img/back_bump.217217f9.jpg";